module.exports = __webpack_public_path__ + "./JoannaPhoto_52d81c5cc4c778dc591633d720719727.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/JoannaPhoto.png
// module id = 495
// module chunks = 0